import { CAP_HISTORICAL_DOCUMENTS_ACTION_TYPES } from '@constants/actionTypes/capHistoricalDocumentsActionTypes';
import { PAGE_SIZE } from '@constants/common.constants';
import {
    HISTORICAL_DOCUMENTS_DEFAULT_SORT_COLUMN,
    HISTORICAL_DOCUMENTS_DEFAULT_SORT_ORDER,
    HISTORICAL_DOCUMENTS_INITIAL_PAGE_NUMBER,
} from '@modules/historical-documents/constants';
import type { ICapHistoricalDocumentsListState } from '@modules/historical-documents/cap/cap.types';

export const INITIAL_STATE: ICapHistoricalDocumentsListState = {
    hasLoaded: false,
    documents: [],
    totalCount: 0,
    pageNumber: HISTORICAL_DOCUMENTS_INITIAL_PAGE_NUMBER,
    pageSize: PAGE_SIZE,
    totalPages: 0,
    sortColumn: HISTORICAL_DOCUMENTS_DEFAULT_SORT_COLUMN,
    sortOrder: HISTORICAL_DOCUMENTS_DEFAULT_SORT_ORDER,
    hasLoadError: false,
};

function capHistoricalDocumentsReducer(
    state = INITIAL_STATE,
    action: { type?: string; payload?: ICapHistoricalDocumentsListState } = {},
) {
    switch (action.type) {
        case CAP_HISTORICAL_DOCUMENTS_ACTION_TYPES.SET_CAP_HISTORICAL_DOCUMENTS: {
            if (!action.payload) {
                return state;
            }

            return { ...state, ...action.payload };
        }
        case CAP_HISTORICAL_DOCUMENTS_ACTION_TYPES.RESET_CAP_HISTORICAL_DOCUMENTS:
            return INITIAL_STATE;
        default:
            return state;
    }
}

export default capHistoricalDocumentsReducer;
